import { useNavigate } from 'react-router-dom';
import { paths } from '@/routes/paths';
import type { ActiveProcessing } from '@/services/api/processService';

interface ResearchHomeRunningProps {
  active: ActiveProcessing;
}

export default function ResearchHomeRunning({ active }: ResearchHomeRunningProps) {
  const navigate = useNavigate();
  const runPct = Math.max(0, Math.min(100, Math.round(active.overallPercentage ?? 0)));
  const runHref =
    active.processType === 'financial_verticals'
      ? paths.financialVerticals
      : active.processType === 'strategic_buyer_list'
        ? paths.strategic
        : paths.targetList;
  const runStage =
    active.currentStageName ||
    active.activityMessage ||
    active.currentStage ||
    active.message ||
    'Working';

  return (
    <button
      type="button"
      className="rh-running"
      onClick={() => navigate(runHref, { state: { resumeActive: active } })}
    >
      <div className="rh-running-icon">
        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
      </div>
      <div className="rh-running-body">
        <div className="rh-running-row">
          <p className="rh-running-title">A research run is in progress</p>
          <span className="rh-running-pct">{runPct}%</span>
        </div>
        <p className="rh-running-stage">{runStage}</p>
        <div className="rh-running-bar" aria-hidden="true">
          <div className="rh-running-bar-fill" style={{ width: `${runPct}%` }} />
        </div>
      </div>
      <i className="bi bi-arrow-right rh-running-chevron" aria-hidden="true" />
    </button>
  );
}
